import { FormattedMessage } from 'react-intl';
import { DateHistoryEntry } from '../types';
import DateHistoryTable from './DateHistoryTable';

interface Props {
  entries: DateHistoryEntry[];
}

export default function StatsPanelView({ entries }: Props) {
  if (entries.length === 0) {
    return (
      <div className="flex items-center justify-center rounded-2xl border border-slate-200 bg-slate-50/50 px-6 py-10 text-center text-slate-500">
        <FormattedMessage id="stats.table.empty" />
      </div>
    );
  }

  return (
    <DateHistoryTable entries={entries} />
  );
}
